/**
 * @description Generate sync action creator
 * @param type: String
 * @returns Object
 */
const actionCreator =
  (type) =>
  (payload = {}, path) => {
    let obj = {
      type,
    };
    if (payload != null) {
      obj = Object.assign({}, obj, { payload });
    }
    if (path != null) {
      obj = Object.assign({}, obj, { path });
    }
    return obj;
  };

/**
 * @description Get initial state for API requests
 * @returns Object
 */
const getNormalApiInitialState = () => ({
  pending: false,
  error: false,
  success: false,
});

/**
 * @description Generate async action creator
 * @param pending: String
 * @param success: String
 * @param error: String
 * @returns Object
 */
const asyncNormalActionCreator = (pending, success, error) => ({
  pending: actionCreator(pending),
  success: actionCreator(success),
  error: actionCreator(error),
});

const getNormalAPIState = (newState = {}) => ({
  ...getNormalApiInitialState(),
  ...newState,
});

/**
 * @description Generate async action creator
 * @param pending: String
 * @param success: String
 * @param error: String
 * @returns Object
 */
const asyncActionCreator = (pending, success, error, fetched) => ({
  pending: actionCreator(pending),
  success: actionCreator(success),
  error: actionCreator(error),
  fetched: actionCreator(fetched),
});

/**
 * @description Get initial state for API requests
 * @returns Object
 */
const getApiInitialState = () => ({
  pending: false,
  error: false,
  success: false,
  fetched: false,
});

/**
 * @description Get initial state for API requests
 * @returns Object
 */
const getInitialPendingState = () => ({
  pending: true,
  error: false,
  success: false,
  fetched: false,
});

const getAPIState = (newState = {}) => ({
  ...getApiInitialState(),
  ...newState,
});

const apiFetchedState = (newState = {}, currentState = {}) =>
  newState?.fetched !== undefined
    ? {
        ...getApiInitialState(),
        ...newState,
      }
    : {
        ...getApiInitialState(),
        ...newState,
        ...{ fetched: currentState?.fetched },
      };

const apiStateCreator = getAPIState;

export {
  actionCreator,
  asyncActionCreator,
  getApiInitialState,
  getAPIState,
  apiStateCreator,
  apiFetchedState,
  getInitialPendingState,
  getNormalApiInitialState,
  asyncNormalActionCreator,
  getNormalAPIState,
};
